import React, { useCallback, useEffect, useState } from 'react';
import NQTCheckBox from '../NQTCheckBox/NQTCheckBox';
import { CHECKBOX_GROUP_TYPES } from '../NQTCheckBox/NQTCheckBox.models';
import { NQTMixedCheckBoxProps } from './NQTMixedCheckBox.models';

import { ReactComponent as Caret} from '../../images/ico-drawer.svg';
import { ReactComponent as CaretDisabled} from '../../images/ico-drawer-disabled.svg';
import './NQTMixedCheckBox.scss';
import { isNull } from 'lodash';

export const NQTMixedCheckBox = (
  {
    checkBoxObj,
    childLabelAttribute,
    childStyle,
    collapsable=false,
    containerClass,
    defaultCollapsed=false,
    id,
    label,
    type,
    updateHandler,
    disabled
  }: NQTMixedCheckBoxProps
):JSX.Element => {
  const [childrenStyle, setChildrenStyle] = useState({ paddingLeft: '32px'} as React.CSSProperties);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(defaultCollapsed);
  const [isIndeterminate, setIsIndeterminate] = useState(
    checkBoxObj.childList &&
    !!checkBoxObj.childList.filter(child => child.isSelected).length &&
    checkBoxObj.childList.filter(child => child.isSelected).length !== checkBoxObj.childList.length
  );
  const [rerender, setRerender] = useState<boolean>(false);

  const parentHandler = useCallback((type: CHECKBOX_GROUP_TYPES): void => {
    if (isIndeterminate) {
      checkBoxObj.isSelected = true;
      checkBoxObj.childList.forEach(ch => ch.isSelected = true);
      setIsIndeterminate(false);
    } else {
      checkBoxObj.childList.forEach(ch => ch.isSelected = checkBoxObj.isSelected);
      setRerender(!rerender);
    }
    updateHandler && updateHandler(type, checkBoxObj);
  }, [checkBoxObj, isIndeterminate, rerender, updateHandler]);

  const childHandler = useCallback((type: CHECKBOX_GROUP_TYPES): void => {
    if (checkBoxObj.childList) {
      const selectedChildren = checkBoxObj.childList.filter(child => child.isSelected);
      // user checked all boxes by themself
      if (selectedChildren.length === checkBoxObj.childList.length) {
        checkBoxObj.isSelected = true;
      } else {
        checkBoxObj.isSelected = false;
      }
      setIsIndeterminate( !!selectedChildren.length && selectedChildren.length !== checkBoxObj.childList.length);
      updateHandler && updateHandler(type, checkBoxObj);
    }
  }, [checkBoxObj, updateHandler]);

  useEffect(() => {
    if (childStyle && childStyle !== null) {
      setChildrenStyle(childStyle);
    }
  }, [childStyle, disabled]);

  // prevents indeterminate state and isSelected state from both being set
  // simultaneously
  useEffect(() => {
    setIsIndeterminate(
      checkBoxObj.childList &&
      !!checkBoxObj.childList.filter(child => child.isSelected).length &&
      checkBoxObj.childList.filter(child => child.isSelected).length !== checkBoxObj.childList.length
    );
  }, [checkBoxObj.childList, checkBoxObj.isSelected]);


  return (
    <div className='nqt-mixed-checkbox'>
      <NQTCheckBox key={`${id}-parent-node`}
        checkBoxObj={checkBoxObj}
        // containerClass={`${disabled ? 'disabled' : '' }`} 
        updateHandler={parentHandler}
        isMixed={true}
        disabled={disabled}
        ariaControls={checkBoxObj.childList?.map((_, i) => id + '-' + i.toString()).join(' ')}
        {...{id, containerClass, isIndeterminate, label, type }} >
        {
          collapsable &&
          <span
            className={`${disabled ? 'disabled' : '' } nqt-mixed-checkbox--expand-collapse` }
            tabIndex={0}
            role='button'
            aria-expanded={!isCollapsed}
            aria-controls={`${id}-child-controls`}
            aria-label={`Toggle ${label} options`}
            onClick={disabled ? isNull : () => setIsCollapsed(!isCollapsed)}
            onKeyUp={(e) => {(e.key === 'Enter' || e.key === ' ') && setIsCollapsed(!isCollapsed);}}>
            { disabled ? <><CaretDisabled width={20} height={20} style={{ transform: isCollapsed ? 'rotate(90deg)' : 'rotate(180deg)' }}/></> : <><Caret width={20} height={20} style={{ transform: isCollapsed ? 'rotate(90deg)' : 'rotate(180deg)' }}/></>  }
            
          </span>
        }
      </NQTCheckBox>
      <ul id={`${id}-child-controls`} className={`nqt-mixed-check--children${(collapsable && isCollapsed) ? ' d-none' : ''}`}>
        {
          checkBoxObj.childList.map((child, index) => {
            return (
              <NQTCheckBox key={`${id}-${index}-child-node`}
                containerStyle={childrenStyle}
                disabled={disabled}
                checkBoxObj={child}
                id={`${id}-${index}`}
                label={child[childLabelAttribute]}
                updateHandler={childHandler}
                containerClass={`${disabled ? 'disabled' : '' }`}
                {...{type}} />
            );
          })
        }
      </ul>

    </div>
  );
};

export default NQTMixedCheckBox;